import AjaxUtil from '../../axios/axios';

/**
 * get course list for lms 
 */
export const getLMSCourses = async(userid) => {    
    try {
        return await AjaxUtil.sendRequest(`lmscourses/${userid}`, {}, false, { method: 'get', showError:true, isProfile:false});
    } catch (error) {
        throw error;
    }
 }

 /**
 * get LMS course modules list 
 */
export const getLMSCourseModule = async(id,userid) => {    
    try {
        return await AjaxUtil.sendRequest(`lmscourseModules/${userid}/${id}`, {}, false, { method: 'get', showError:true, isProfile:false});
    } catch (error) {
        throw error;
    }
 }

/**
 * post the use activity lms data
 */
export const postUserActivityLms = async(uid,moduleid,id,data) => {  
    try {
        return await AjaxUtil.sendRequest(`lmsActivity/${uid}/${moduleid}/${id}`, data, false, { method: 'put', showError:true, isProfile:false});
    } catch (error) {
        throw error;
    }
 }

 /**
 * post the use test activity lms data
 * t = p -> pretest, t = pp -> posttest
 */
export const postUserTestActivityLms = async(data,testType) => {    
    try {
        return await AjaxUtil.sendRequest(`lmstestActivity?t=${testType}`, data, false, { method: 'put', showError:true, isProfile:false});
    } catch (error) {
        throw error;
    }
 }

 /**
 * post the subscription status for course
 */
 export const subscribeToCourse = async(id,userid) => {    
    try {
        return await AjaxUtil.sendRequest(`lmscourse/${userid}/${id}`, {}, false, { method: 'post', showError:true, isProfile:false});
    } catch (error) {
        throw error;
    }
 }

    /**
     * get course certificate
     * @param {*} id
     * @param {*} userid
    */

 export const getCourseCertificate = async(id,userid) => {    
    try {
        return await AjaxUtil.sendRequest(`lmscoursecert/${userid}/${id}`, {}, false, { method: 'get', showError:true, isProfile:false});
    } catch (error) {
        throw error;
    }
 }